var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTopnavigationnotificationicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 30C17.3652 30 19.2837 28.3213 19.2837 26.25H10.7163C10.7163 28.3213 12.6348 30 15 30ZM29.4234 21.2279C28.1297 20.0115 25.7089 18.1816 25.7089 12.1875C25.7089 7.63477 22.0607 3.99023 17.1415 3.09609V1.875C17.1415 0.839648 16.1826 0 15 0C13.8174 0 12.8585 0.839648 12.8585 1.875V3.09609C7.93931 3.99023 4.2911 7.63477 4.2911 12.1875C4.2911 18.1816 1.87035 20.0115 0.576607 21.2279C0.174823 21.6059 -0.00330191 22.0576 4.62982e-05 22.5C0.00741235 23.4609 0.86924 24.375 2.14959 24.375H27.8504C29.1308 24.375 29.9933 23.4609 30 22.5C30.0033 22.0576 29.8252 21.6053 29.4234 21.2279Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopnavigationnotificationicon);
export default __webpack_public_path__ + "static/media/topnavigationnotificationicon.e14852c1cc94f45d7c11270992703164.svg";
export { ForwardRef as ReactComponent };